const settingsConfig = {
	layout: {
		style: 'layout4',
		config: {} // checkout default layout configs at app/layouts for example  app/layouts/layout1/Layout1Config.js
	},
	customScrollbars: true,
	direction: 'ltr', // rtl, ltr
	theme: {
		main: 'default',
		navbar: 'greyDark',
		toolbar: 'dark5', // mainThemeLight
		footer: 'mainThemeDark'
	}
};

export default settingsConfig;
